import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table'
import Spinner from 'react-bootstrap/Spinner'
import Card from 'react-bootstrap/Card'


function EventDetails({ event, eventType }) {
    return (
        event && 
            eventType == "workout" ?
            <Card>
                <Card.Body>
                    <small>
                    <p style={{ whiteSpace: 'pre-wrap' }}>{event?.longNote}</p>  

                        <Table>
                            <thead>
                                <tr>
                                    <th>Exercise Name</th>
                                    <th>Sets</th>
                                    <th>Reps</th>
                                    <th>Weight</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    event?.exerciseArray?.map(exercise => (
                                        <tr>
                                            <td>{exercise?.exercise_name}</td>
                                            <td>{exercise?.Sets}</td>
                                            <td>{exercise?.Reps}</td>
                                            <td>{exercise?.Weight}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </Table>
                    </small>
                </Card.Body>
            </Card> : eventType === "nutrition" ?
                <Card>
                    <Card.Body>
                        <small>
                            {event?.longNote}

                            <Table>
                                <thead>
                                    <tr>
                                        <th>Food Name</th>
                                        <th>Cal</th>
                                        <th>Pro</th>
                                        <th>Carb</th>
                                        <th>Fat</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        event?.foodArray?.map(food => (
                                            <tr>
                                                <td>{food?.food_name}</td>
                                                <td>{food?.calories}</td>
                                                <td>{food?.protein}</td>
                                                <td>{food?.carbs}</td>
                                                <td>{food?.fat}</td>
                                            </tr>
                                        ))
                                    }

                                </tbody>
                            </Table>
                        </small>
                    </Card.Body>
                </Card> :
                eventType === "task" ?
                    <Card>
                        <Card.Body>
                            <small>
                                {event?.longNote}
                            </small>
                        </Card.Body>
                    </Card>
                    : <div> </div>

    )
}


export default EventDetails;